import React from "react";
import { Route, Routes } from "react-router-dom";
import "./Home.scss";

import Dashboard from "../Pages/Dashboard/Dashboard";
import SoftwareUpdate from "../Pages/SoftwareUpdate/SoftwareUpdate";
import Modules from "./SoftwareUpdate/Modules/Modules";
import Plans from "./SoftwareUpdate/Plans/Plans";
import Pricing from "./SoftwareUpdate/Pricing/Pricing";
import TenantManager from "../Pages/Tenant/TenantManager";

function Home() {
  return (
    <div className="home-container">
      <div className="main-content">
        <div className="content">
          <Routes>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="software-update/*" element={<SoftwareUpdate />}>
              <Route path="modules" element={<Modules />} />
              <Route path="plans" element={<Plans />} />
              <Route path="pricing" element={<Pricing />} />
            </Route>
            <Route path="tenant-manager" element={<TenantManager />} />
            <Route path="*" element={<Dashboard />} /> {/* Default route */}
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Home;
